enum CoordinateSystem {
    EPSG3879 = 'GK25FIN',
    EPSG4326 = 'wgs84',
    EPSG2392 = 'KKJ',
}

export default CoordinateSystem;
